import React from 'react';

import {
  Image,
  ImageGrid,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Text } from '../../../components';
import { API_URL } from '../../../config/constants';
import { ParagraphTextImageGrid as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphTextImageGridProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphTextImageGrid: React.FC<ParagraphTextImageGridProps> = ({ entity }) => {
  const paragraphTextMedia = entity.toJS();

  const title = paragraphTextMedia.field_title[0]?.value;
  const body = paragraphTextMedia.field_body[0].processed || '';
  const link = paragraphTextMedia.field_link[0];
  const linkTitle = link?.title;
  const linkUri = link?.alias || link?.uri;
  const linkTarget = link?.options?.attributes?.target;
  const secondaryLink = paragraphTextMedia.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUri = secondaryLink?.alias || secondaryLink?.uri;
  const secondaryLinkTarget = secondaryLink?.options?.attributes?.target;
  const media = paragraphTextMedia.field_media_items;

  const imageGridItems = media.map((item) => {
    const caption = item.entity.field_caption[0]?.value;
    const imageStyles = item.styles;
    const src = [
      `${API_URL}${imageStyles?.ratio_1_1_xs || ''}`,
      `${API_URL}${imageStyles?.ratio_1_1_sm || ''}`,
      `${API_URL}${imageStyles?.ratio_1_1_md || ''}`,
      `${API_URL}${imageStyles?.ratio_1_1_xl || ''}`,
    ];

    return (
      <Image
        src={src}
        alt={caption}
      />
    );
  });

  return (
    <div>
      <Text
        title={title}
        text={body}
        link={linkUri}
        linkText={linkTitle}
        target={linkTarget}
        secondaryLink={secondaryLinkUri}
        secondaryLinkText={secondaryLinkTitle}
        secondaryTarget={secondaryLinkTarget}
      />
      <ImageGrid
        items={imageGridItems}
      />
    </div>
  );
};

export default ParagraphTextImageGrid;
